import React from 'react'
import PropTypes from 'prop-types'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import HeadingBeta from '../headings/heading-beta'
import Breadcrumbs from '../lists/breadcrumbs'
import CardList from '../cards/card-list'
import CardListItem from '../cards/card-list-item'
import { basicAuctionShape } from '../../services/prop-types'
import withAuctionCard from '../../services/mycharity/withAuctionCard'

const EnhancedCardListItem = withAuctionCard(CardListItem)

const renderAuctionsList = auctions =>
  auctions.map((auction, index) => (
    <EnhancedCardListItem auction={auction} key={index} />
  ))

const CharityOurAuctions = props => {
  const {
    crumbs,
    charityName,
    upcomingAuctions,
    finishedAuctions,
    ourEventsText,
    upcomingText,
    finishedText
  } = props
  return (
    <div>
      <div className='dark-header'>
        <Breadcrumbs current={ourEventsText} crumbs={crumbs} />
        <HeadingBeta>{charityName}</HeadingBeta>
      </div>
      <Tabs>
        <TabList>
          <Tab>
            {upcomingText} ({upcomingAuctions.length})
          </Tab>
          <Tab>
            {finishedText} ({finishedAuctions.length})
          </Tab>
        </TabList>
        <TabPanel>
          <CardList>{renderAuctionsList(upcomingAuctions)}</CardList>
        </TabPanel>
        <TabPanel>
          <CardList>{renderAuctionsList(finishedAuctions)}</CardList>
        </TabPanel>
      </Tabs>
    </div>
  )
}

CharityOurAuctions.propTypes = {
  charityName: PropTypes.string,
  upcomingAuctions: PropTypes.arrayOf(basicAuctionShape).isRequired,
  finishedAuctions: PropTypes.arrayOf(basicAuctionShape).isRequired,
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      linkText: PropTypes.string,
      linkUrl: PropTypes.string
    })
  ),
  // translations
  ourEventsText: PropTypes.string,
  upcomingText: PropTypes.string,
  finishedText: PropTypes.string
}

export default CharityOurAuctions



// WEBPACK FOOTER //
// ./src/ui/views/charity-our-auctions.js